import { lazy } from 'react';
import { CACHE_KEY } from '../../../constants/commonConstants';
import TvingLogModule from '../../tving-log-module/TvingLogModule';
var retry = function (fn, retriesLeft, interval) {
    if (retriesLeft === void 0) { retriesLeft = 5; }
    if (interval === void 0) { interval = 1000; }
    return new Promise(function (resolve, reject) {
        fn()
            .then(resolve)
            .catch(function (error) {
            TvingLogModule.warn("[lazyRetry] retriesLeft: ".concat(retriesLeft, ", error: ").concat(error));
            setTimeout(function () {
                if (retriesLeft <= 1) {
                    TvingLogModule.errorSentry("[lazyRetry] refresh retriesLeft: ".concat(retriesLeft, ", page: ").concat(error));
                    var chunkRetryCount = localStorage.getItem(CACHE_KEY.CHUNK_RETRY_COUNT);
                    if (chunkRetryCount && Number(chunkRetryCount) >= 3) {
                        localStorage.removeItem(CACHE_KEY.CHUNK_RETRY_COUNT);
                        // eslint-disable-next-line no-alert
                        window.location.href = '/exit/exit.html';
                        return;
                    }
                    localStorage.setItem(CACHE_KEY.CHUNK_RETRY_COUNT, chunkRetryCount ? "".concat(Number(chunkRetryCount) + 1) : '1');
                    window.location.reload();
                    return;
                }
                retry(fn, retriesLeft - 1, interval).then(resolve, reject);
            }, interval);
        });
    });
};
var lazyRetry = function (component, retries, interval) {
    return lazy(function () { return retry(component, retries, interval); });
};
export default lazyRetry;
